//submit document
export const POST_CANDIDATES_INTEREST_STATUS = "POST_CANDIDATES_INTEREST_STATUS"
export const POST_CANDIDATES_INTEREST_STATUS_SUCCESS = "POST_CANDIDATES_INTEREST_STATUS_SUCCESS"
export const POST_CANDIDATES_INTEREST_STATUS_FAILED = "POST_CANDIDATES_INTEREST_STATUS_FAILED"
